import { HttpResult } from 'widgets-for-react'
import { BlocksState } from '../cmsPage/blocks/blocksState'
import { transformToBlocks } from '../cmsPage/sharepointPageApi/transformers/pageDataToPage'

export type CrisisBannerData = {
  Content: string
}

export const crisisBannerApi = async (): Promise<HttpResult<BlocksState>> => {
  const res = await fetch(`/api/v1/pages/crisis-banner/`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: CrisisBannerData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: transformToBlocks(data.Content),
  }
}
